import { handleMobileAppCarousel } from 'views/assets/scripts/handleMobileAppCarousel'
import registerSliderStretcher from 'views/assets/scripts/registerSliderStretcher'
import runScripts from 'views/assets/scripts/runScripts'
import scrollableTables from 'views/assets/scripts/scrollableTables'
import { showWholeCollapsibleContent } from 'views/assets/scripts/showWholeCollapsibleContent'
import { initSlider as slider } from 'views/assets/scripts/slider'
import toggleClass from 'views/assets/scripts/toggleClass'
import video from 'views/assets/scripts/video'

runScripts(
  handleMobileAppCarousel,
  slider,
  showWholeCollapsibleContent,
  toggleClass,
  registerSliderStretcher,
  scrollableTables,
  video
)
